// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  margin-left: 16px;
  margin-bottom: 8px;
  min-width: 95px;
}

.tab-content {
  display: flex;
  flex-wrap: wrap;
}

fieldset {
  border-radius: 5px;
  border-color: lightgray;
  border-block-color: lightgray;
  border-block-style: solid;
  border-bottom-color: lightgray;
  border-left-style: solid;
  border-right-color: lightgray;
  border-right-style: solid;
  border-left-color: lightgray;
  border-width: thin;
}

legend {
  color: gray;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/search-bar/search-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,yBAAA;EACA,8BAAA;EACA,wBAAA;EACA,6BAAA;EACA,yBAAA;EACA,4BAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;AACJ","sourcesContent":["button {\n    margin-left: 16px;\n    margin-bottom: 8px;\n    min-width: 95px;\n}\n\n.tab-content {\n    display: flex;\n    flex-wrap: wrap;\n}\n\nfieldset {\n    border-radius: 5px;\n    border-color: lightgray;\n    border-block-color: lightgray;\n    border-block-style: solid;\n    border-bottom-color: lightgray;\n    border-left-style: solid;\n    border-right-color: lightgray;\n    border-right-style: solid;\n    border-left-color: lightgray;\n    border-width: thin;\n}\n\nlegend {\n    color: gray;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
